import { createFileRoute } from "@tanstack/react-router";
import { InstanceAdministratorsSection } from "@/components/instance/instance-administrators-section";
import {
	useInstanceAdmission,
	useRecheckInstanceAdmission,
} from "@/components/instance/instance-admission";

export const Route = createFileRoute("/instance/")({
	component: InstanceOverviewPage,
});

/**
 * The overview page: who administers this ELASO Instance. The Organisations and
 * the diagnostics have pages of their own (`instance/organizations/`,
 * `instance/diagnostics.tsx`). The guard, the socket claim and the shell all
 * live on the layout route (`instance/route.tsx`), so anything reached from here
 * is already known to be a signed-in Instance Manager owner or admin on a live
 * connection.
 */
function InstanceOverviewPage() {
	const { tier } = useInstanceAdmission();
	const recheck = useRecheckInstanceAdmission();

	return (
		<div className="flex flex-col items-center gap-4 p-4 md:p-8">
			<InstanceAdministratorsSection
				callerTier={tier}
				onSteppedDown={recheck}
			/>
		</div>
	);
}
